import { useTranslation } from 'react-i18next';

import { LoadingSpinner } from 'components/Loading/LoadingSpinner';
import { AnnotationNavigationActions } from 'components/WebEDI/AnnotationNavigationActions/AnnotationNavigationActions';

export const LoadingErrors = () => {
  const { t } = useTranslation();

  return (
    <AnnotationNavigationActions isLoading>
      <LoadingSpinner variant="error" sizeClassName="size-5" />
      <span className="text-xs font-medium text-red-700">
        {t('webedi:viewDocument.messageErrorBanner.loadingDatachecks.calculatingAffectedFields')}
      </span>
    </AnnotationNavigationActions>
  );
};
